module.exports = __webpack_public_path__ + "img/icon-cardgames-yellow.76041b8e.svg";